module.exports = __webpack_public_path__ + "media/dashboard/assets/images/typing-929e3aeb589b7668d0b4ff57f73e17e3.gif";